let arr=document.cookie.split(";");
let obj={};
for(let i=0;i<arr.length;i++){
  arr[i]=arr[i].replace(/(^\s*) | (\s*$)/g,"");
  obj[arr[i].split("=")[0]]=arr[i].split("=")[1];
}
module.exports = {
  DATA_SERVER: "/service/",
  // ETL_CONFIG_SERVER: "http://192.168.0.14:81",
  ETL_CONFIG_SERVER: "http://10.1.1.237:81",
  // ETL_CONFIG_SERVER: "http://60.29.212.129:81",
  // ETL_CONFIG_SERVER: "http://192.168.0.13:8000",
  advertiser_id:obj["advertiser_id"],
  userType:obj["userType"],
  ETL_STARTUP_PARAMS: {
    "Xmx": [512, 50 * 1024],
    "Xms": [512, 50 * 1024],
    "Xss": [1, 20],
  }
};



//////////////////
// WEBPACK FOOTER
// ./static/js/config.js
// module id = wAX/
// module chunks = 17